import { useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import { Icon } from '~/components/atomic';
import IconButtonWrapper from '~/components/common/IconButtonWrapper/IconButtonWrapper';
import { PAGE_ROUTE } from '~/constants';

export default function RightMenu() {
  const navigate = useNavigate();
  // const handleGoBill = () => {
  //   window.open('https://portal.hey-d.ai', '_blank');
  // };
  return (
    <>
      <ButtonBox>
        <IconButtonWrapper
          as='button'
          onClick={() => navigate(PAGE_ROUTE.SETTINGS)}
        >
          <Icon color='content_light_1' size={28} iconName={'Setting'} />
        </IconButtonWrapper>
      </ButtonBox>
      <ButtonBox>
        <IconButtonWrapper
          as='button'
          onClick={() => navigate(PAGE_ROUTE.REPORT)}
        >
          <Icon color='content_light_1' size={28} iconName='Report' />
        </IconButtonWrapper>
      </ButtonBox>
    </>
  );
}

export const ButtonBox = styled.div`
  position: relative;
  width: 44px;
`;
